import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { EMPTY } from '../../../../constants';

export function taxonomyAttributes({ attribute, channel, preview }) {
  const property = attribute.get('property');

  return {
    payload: Map({
      type: OPERATIONS[channel].TAXONOMY_ATTRIBUTES,
      value: Map({
        [property]: Map({
          values: preview.getIn([property, 'values'], EMPTY.LIST),
          valueIds: preview.getIn([property, 'valueIds'], EMPTY.LIST),
          scaleId: preview.getIn([property, 'scaleId']) || null,
        }),
      }),
    }),
  };
}
